const getSearch = () => document.getElementById('primary-search');

const focusOnSearch = () => {
    const $searchBox = getSearch();
    $searchBox.focus();
};

const focus = () => {
    focusOnSearch();
};

export { focus };
